export default __webpack_public_path__ + "static/media/Chhattisgarhi_am_1.04749d9c.mp3";